<!--
 * @Author: 曹捷
 * @Date: 2021-10-23 17:14:06
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-07-01 16:20:46
 * @Description: fileContent
-->
<template>
  <div class="y-navbar">
    <img class="n-back" src="@/assets/images/navbar.png" width="100%" height="100%" />
    <div class="y-navbar flex-l-r ">
      <div class="left flex-c">
        <obitEnv>
          <template #zs>
            <span class="m-r-20 f-b p-l-20" style="font-size:28px;">智水环境远控平台</span>
          </template>
          <template #xj>
            <span class="m-r-20 f-b p-l-20" style="font-size:28px;">老板仓库</span>
          </template>
          <img class="n-logo" src="@/assets/images/login2.png" alt="">
        </obitEnv>
        <mainAppBreadCrumbVue v-if="meta.mainApp"></mainAppBreadCrumbVue>
        <breadCrumb v-else></breadCrumb>
      </div>
      <div class="right-menu">
        <div class="system-center flex">
          <a-popover overlayClassName="notice-main border" v-model:visible="noticeVisible" trigger="click">
            <template #content>
              <div class="n-t flex-l-r b-b">
                <span>平台消息</span>
                <a-button type="link" @click="toAllMsg">全部消息</a-button>
              </div>
              <div class="notice-content background">
                <div class="n-item body b-b" @click="toDetails(item)" v-for="(item,index) in noticeList" :key="index">
                  <div class="title">{{item.noticeTitle}}</div>
                  <div class="context">您收到一条消息</div>
                  <div class="time">{{item.createTime}}</div>
                </div>
              </div>
            </template>
            <span class="center">
              <a-tooltip class="hover-operator  ">
                <template #title>通知</template>
                <i class="iconfont icon-notice  n-item"></i>
              </a-tooltip>
            </span>
          </a-popover>
          <a-dropdown>
            <a class="flex-l-a center ant-dropdown-link  " @click.prevent>
              <span class="user-name">{{userInfo.userName}}</span>
              <obitEnv>
                <template #zs>
                  <img class="user-icon" src="@/assets/zs/images/logo.svg" alt="">
                </template>
                <template #xj>
                  <img class="user-icon" src="@/assets/images/login/xj1.png" alt="">
                </template>
                <img class="user-icon" src="@/assets/images/head.png" alt="">
              </obitEnv>
            </a>
            <template #overlay>
              <a-menu>
                <a-menu-item @click="logout">
                  <span>
                    <i class="iconfont icon-dengchu p-r-5"></i>登出
                  </span>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed, compile, inject } from 'vue'
import { logout } from 'obit-wui/utils/auth'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import breadCrumb from 'obit-wui/components/bread-crumb'
import mainAppBreadCrumbVue from './mainAppBreadCrumb.vue'
import { pushState } from './../hook/history'
export default {
  components: { breadCrumb, mainAppBreadCrumbVue },
  setup (props, context) {
    let _data = reactive({
      noticeVisible: false,
      inp: '',
      noticeList: [
        {
          info: 'Width消息内容，此条消息为测试的消息内容，支持自动换行。', title: '平台的消息', time: 'fsdhi 20: 13'
        }
      ],
      infoHtml: `<a-input v-modal:value="inp"/>`
    })
    // let info = compile('<a-input v-modal:value="inp"></a-input>')
    let router = useRouter()
    let route = useRoute()
    let store = useStore()
    let http = inject('http')
    let _computed = {
      config: computed(() => config),
      meta: computed(() => route.meta),
      appInfo: computed(() => store.state.user.app),
      userInfo: computed(() => store.getters['user/userInfo']),
    }
    let _methods = {
      logout () {
        console.log('🚀 ~ file: Navbar.vue ~ line 106 ~ logout ~ logout',)
        logout(router)
      },
      toDetails (item) {
        _data.noticeVisible = false
        pushState(`/message/msg/core/coreDetails?noticeId=${item.noticeId}`)
      },
      toAllMsg () {
        _data.noticeVisible = false
        pushState('/message/msg/coreIndex')
      },
      initMsg () {
        http.commonPost('system/notice/selectNoticeTop4').then(res => {
          _data.noticeList = res
        })
      }
    }
    if (_computed.userInfo && _computed.userInfo.value && _computed.userInfo.value.userId) {
      _methods.initMsg()
    }
    return {
      ...toRefs(_data),
      ..._computed,
      ..._methods
    }
  }
}
</script>

<style lang="less"  >
.notice-main {
  width: 370px;
  padding-top: 0 !important;
  .ant-popover-inner-content {
    padding: 0;
  }
  .n-item {
    padding: 10px;
    padding-bottom: 5px;
    cursor: pointer;
  }
  .title {
    padding-bottom: 2px;
  }
  .context,
  .time {
    font-size: 12px;
    color: @border;
  }
  .n-t {
    height: 40px;
    line-height: 40px;
    align-items: center;
    padding: 0 24px;
  }
  .notice-content {
    padding: 8px;
    padding-bottom: 30px;
  }
}
.y-navbar {
  width: 100%;
  height: 100%;
  position: relative;
  .n-back {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .n-logo {
    margin-left: 32px;
    height: 35px;
    margin-right: 40px;
  }
  .flex-l-r {
    align-items: center;
  }
  .user-icon {
    height: 36px;
    width: 36px;
    border-radius: 50px;
  }
  .right-menu {
    .n-item {
      font-size: 22px;
    }
    .center {
      font-size: 22px;
      padding: 0 17px;
      cursor: pointer;
      transition: all 0.6s;
      .user-name {
        font-size: 16px;
        color: #fff;
        padding-right: 10px;
      }
    }
    .center:hover {
      background: @bodyBackColor;
    }
  }
}
</style>